import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IRichLogData } from "@ryde/shared";

import {
  RichLogsPagination,
  RichViewLogItem,
  useRichLogsContent,
} from "../../rich-logs-components";
import { ProductionLogsFilters } from "./production-logs.filters";

interface IProductionLogsContent {
  logData: IRichLogData | undefined;
  hasExternalLogs?: boolean;
  onRefreshLogsClick?: () => void;
  isRefreshLogsDisabled?: boolean;
}

export const ProductionLogsContent: FC<IProductionLogsContent> = ({
  logData,
  hasExternalLogs,
  onRefreshLogsClick,
  isRefreshLogsDisabled,
}) => {
  const { t } = useTranslation();
  const {
    searchText,
    currentPage,
    filteredAndSortedLogs,
    totalPages,
    startIndex,
    paginatedLogs,
    handleLogItemClick,
  } = useRichLogsContent({ logData });

  return (
    <>
      {logData && (
        <ProductionLogsFilters
          logData={logData}
          filteredLogsCount={filteredAndSortedLogs?.length}
          hasExternalLogs={hasExternalLogs}
          onRefreshLogsClick={onRefreshLogsClick}
          isRefreshLogsDisabled={isRefreshLogsDisabled}
        />
      )}

      <RichLogsPagination totalPages={totalPages} currentPage={currentPage} />

      {paginatedLogs.length ? (
        paginatedLogs.map((record, index) => (
          <RichViewLogItem
            key={`${record.timestamp}-${startIndex + index}`}
            record={record}
            onItemClick={handleLogItemClick}
            searchText={searchText}
          />
        ))
      ) : (
        <p className="log__no-logs-found">
          {t("rideProduction.formLabel.noLogsFound")}
        </p>
      )}

      <RichLogsPagination totalPages={totalPages} currentPage={currentPage} />
    </>
  );
};
